import { NgModule } from '@angular/core';
import { IfActiveProfileDirective } from './active-profile.directive';
import { ProfileBlockDirective } from './profile-block.directive';
import { ProfileNotificationToggleDirective } from './profile-notification-toggle.directive';

@NgModule({
    imports: [],
    exports: [
        IfActiveProfileDirective,
        ProfileNotificationToggleDirective,
        ProfileBlockDirective
    ],
    declarations: [
        IfActiveProfileDirective,
        ProfileNotificationToggleDirective,
        ProfileBlockDirective
    ],
    providers: [],
})
export class KatchaProfileModule { }
